import Avatar from 'modules/auth/components/Avatar'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { generateSlug, getTitle } from 'utils/helpers'
import { NotificationStyled } from '../styles'

export function NotificationItem(props) {
  const { noti } = props
  return (
    <NotificationStyled className={`${noti?.is_read ? 'read' : 'unread'}`} onClick={() => props.onMarkAsRead(noti?.notification_users_id)}>
      {noti?.subtype === 'page_mentioned' && noti?.page && (
        <Link className='w-100 d-flex' to={`${noti?.page?.is_draft ? `/pages/drafts/edit/${generateSlug(noti?.page)}` : `/page/${generateSlug(noti?.page)}`}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has mentioned you on a page <span className='font-weight-600'>{getTitle(noti?.page?.title)}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'page_restored' && noti?.page && (
        <Link className='w-100 d-flex' to={`${noti?.page?.is_draft ? `/pages/drafts/edit/${noti?.page?.uuid}` : `/page/${noti?.page?.uuid}`}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has restored a version in this page <span className='font-weight-600'>{getTitle(noti?.page?.title)}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'page_comment_mentioned' && noti?.page && (
        <Link className='w-100 d-flex' to={`${noti?.page?.is_draft ? `/pages/drafts/edit/${noti?.page?.uuid}` : `/page/${noti?.page?.uuid}`}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has mentioned you in comment on a page <span className='font-weight-600'>{getTitle(noti?.page?.title)}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'member_joined' && (
        <div className='w-100 d-flex'>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has joined your team
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </div>
      )}
      {noti?.subtype === 'added_to_group' && (
        <div className='w-100 d-flex'>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has added you to <span className='font-weight-600'>{noti?.team.name}</span> group
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </div>
      )}
      {noti?.subtype === 'page_comment' && noti?.page && (
        <Link className='w-100 d-flex' to={`${noti?.page?.is_draft ? `/pages/drafts/edit/${noti?.page?.uuid}` : `/page/${noti?.page?.uuid}`}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has commented on the page <span className='font-weight-600'>{getTitle(noti?.page?.title)}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'page_comment_reply' && noti?.page && (
        <Link className='w-100 d-flex' to={`${noti?.page?.is_draft ? `/pages/drafts/edit/${generateSlug(noti?.page)}` : `/page/${generateSlug(noti?.page)}`}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has replied to your comment in <span className='font-weight-600'>{getTitle(noti?.page?.title)}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'new_page_in_category' && noti?.category && noti?.page && (
        <Link className='w-100 d-flex' to={`/page/${generateSlug(noti?.page)}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has added a page in <span className='font-weight-600'>{noti?.category?.name}</span> category
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'updated_page_in_category' && noti?.category && noti?.page && (
        <Link className='w-100 d-flex' to={`/page/${generateSlug(noti?.page)}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> updated the page <span className='font-weight-600'>{getTitle(noti?.page?.title)}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'new_response_in_category' && noti?.category && noti?.page && (
        <Link className='w-100 d-flex' to={`/response/${generateSlug(noti?.page)}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has added a response {noti?.page?.shortcut ? 'with shortcut ' : ''} in{' '}
            <span className='font-weight-600'>{noti?.category?.name}</span> category
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'response_shortcut_add' && noti?.category && noti?.page && (
        <Link className='w-100 d-flex' to={`/response/${generateSlug(noti?.page)}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            {noti?.created_by_user_name} has added the shortcut to <span className='font-weight-600'>{getTitle(noti?.page?.title || '')}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}

      {noti?.subtype === 'response_shortcut_updated' && noti?.category && noti?.page && (
        <Link className='w-100 d-flex' to={`/response/${generateSlug(noti?.page)}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            {noti?.created_by_user_name} has updated the shortcut of <span className='font-weight-600'>{getTitle(noti?.page?.title || '')}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}

      {noti?.subtype === 'response_shortcut_removed' && noti?.category && noti?.page && (
        <Link className='w-100 d-flex' to={`/response/${generateSlug(noti?.page)}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            {noti?.created_by_user_name} has removed the shortcut of <span className='font-weight-600'>{getTitle(noti?.page?.title || '')}</span>
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
      {noti?.subtype === 'added_as_category_owner' && (
        <div className='w-100 d-flex'>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> added you as owner of the category <span className='font-weight-600'>{noti?.category?.name}</span>.
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </div>
      )}
      {noti?.subtype === 'added_as_category_editor' && (
        <div className='w-100 d-flex'>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> added you as editor of the category <span className='font-weight-600'>{noti?.category?.name}</span>.
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </div>
      )}
      {noti?.subtype === 'added_as_category_viewer' && (
        <div className='w-100 d-flex'>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> added you as viewer of the category <span className='font-weight-600'>{noti?.category?.name}</span>.
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </div>
      )}
      {noti?.subtype === 'shared_externally' && noti?.category && noti?.page && (
        <Link className='w-100 d-flex' to={`/page/${generateSlug(noti?.page)}`}>
          <Avatar size={40} user={{ id: noti?.created_by_user_id, name: noti?.created_by_user_name, avatar: noti?.created_by_user_avatar }} />
          <div className='mx-3' style={{ whiteSpace: 'normal' }}>
            <span className='font-weight-600'>{noti?.created_by_user_name}</span> has shared a page externally from <span className='font-weight-600'>{noti?.category?.name}</span> category
            <br />
            <small> {moment.utc(noti?.created_at).local().fromNow()} </small>
          </div>
          {!noti?.is_read && <span className='unread-mark'></span>}
        </Link>
      )}
    </NotificationStyled>
  )
}
